import React from 'react';

const News = () => {
    return (
        <div>
            <h1 className='text-4xl text-center'>Comming soon.</h1>
        </div>
    );
};

export default News;